import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import ErrorPage from "../../shared/ErrorPage";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";

const AddDiscount = () => {
  const [loading, setLoading] = useState(false);

  // REACT FORM HOOKS
  const {
    register,
    resetField,
    handleSubmit,
    formState: { errors },
  } = useForm();

  //SUBMIL FUNCTION
  const onSubmit = async (data) => {
    setLoading(true);
    if (!data?.value || !data?.category) setLoading(false);

    console.log(data);

    //SENDING DATA TO MONGO-DB DATABASE
    await axiosInstance.post("discount/create", data).then((res) => {
      setLoading(false);
      if (res.status === 201) {
        Swal.fire(
          "Saved!",
          `You have successfully added the Discount.`,
          "success"
        ).then(() => {
          resetField("category");
          resetField("value");
        });
      } else {
        Swal.fire("Error!", `Something went wrong`, "error");
      }
      console.log(res.data);
    });

    setLoading(false);
  };

  if (loading === true) Swal.showLoading();
  return (
    <div className="w-full py-6 lg:px-10 md:px-10 sm:px-2 ">
      <p className="text-sm font-bold">Add Discount</p>

      <form className="mt-4 text-xs" onSubmit={handleSubmit(onSubmit)}>
        <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-4">
          <div className="form-control w-full ">
            <label className="label">
              <span className="">CategoryName</span>
            </label>
            <input
              type="text"
              name="category"
              className="input input-bordered text-xs rounded-none w-full "
              {...register("category", {
                required: true,
                message: "This field is required",
              })}
            />
            {errors.category && (
              <label className="label">
                <span className="-alt text-sm text-red-500">
                  This field is required
                </span>
              </label>
            )}
          </div>
          <div className="form-control w-full ">
            <label className="label">
              <span className="">Discount Percentage</span>
            </label>
            <input
              type="number"
              name="value"
              className="input input-bordered text-xs rounded-none w-full "
              {...register("value", {
                required: true,
                message: "This field is required",
              })}
            />
            {errors.value && (
              <label className="label">
                <span className="-alt text-sm text-red-500">
                  This field is required
                </span>
              </label>
            )}
          </div>
        </div>

        <div className="w-full flex justify-center items-center">
          <input
            type="submit"
            value="Upload Discount"
            className="btn btn-success btn-wide rounded-none mt-8"
          ></input>
        </div>
      </form>
      {/* submit  */}
    </div>
  );
};

export default AddDiscount;
